// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f1_5e {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  margin-top: 22px;
}
.ftbiz {
  width: 100%;
  display: flex;
  height: 416px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #f2f4f7;
  border-radius: 12px;
}
.ttJ8Q {
  margin-top: 22px;
  color: #999;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  /* 24px */
  text-transform: capitalize;
}
.E2Zua {
  height: 70vh;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: flex-end;
  gap: 18px;
}
.PQs_q {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 12px;
  overflow-y: auto;
  padding: 22px 18px;
}
.ioom5 {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.ioom5 img {
  max-width: 100%;
  object-fit: contain;
}
.eKfPt {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.PNVpp {
  width: 260px;
  background: #f8f9fa;
  padding: 32px 18px;
  border-radius: 12px;
}
.Yb55x {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.Yb55x div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 2px;
}
.Yb55x div span {
  font-size: 16px;
  font-style: normal;
  line-height: 150%;
  /* 24px */
  text-transform: capitalize;
}
.Yb55x div span:nth-child(1) {
  color: #333;
  font-weight: 700;
}
.Yb55x div span:nth-child(2) {
  color: #666;
  font-weight: 500;
  word-break: break-word;
  max-width: 60%;
}
.cxAdl {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
}
.cxAdl .FtET4 {
  background: #577cf6;
  color: #fff;
  font-weight: 700;
}
.COTML {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: #fc0a0a;
}
.XtmeJ {
  height: 32px;
  color: #333;
  border-radius: 10px;
  font-weight: 500;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cvUploaderWrapper": `f1_5e`,
	"cvUploaderWrapperUpload": `ftbiz`,
	"cvUploaderWrapperUploadTip": `ttJ8Q`,
	"cvUploaderWrapperPreview": `E2Zua`,
	"cvUploaderWrapperPreviewLeft": `PQs_q`,
	"cvUploaderWrapperPreviewLeftContent": `ioom5`,
	"cvUploaderWrapperPreviewLeftPdf": `eKfPt`,
	"cvUploaderWrapperPreviewRight": `PNVpp`,
	"cvUploaderWrapperPreviewRightBox": `Yb55x`,
	"cvUploaderActions": `cxAdl`,
	"primary": `FtET4`,
	"notSupport": `COTML`,
	"uploadBtn": `XtmeJ`
};
export default ___CSS_LOADER_EXPORT___;
